define(function(require, exports, module) {
    var _ = require('underscore');
    var user = require('user');
    var language = require('util/language.util');

    module.exports = {
        /**
         * setBonusName - parse Bonus Props and return correct bonus name
         * @param {[Object]} bonus [Bonus config from IMS response]
         * @param {[Object]} bonusTmpl  [Bonus template from IMS]
         */
        setBonusName: function(bonusTmpl, bonus) {
            var lang = user.get('lang');
            var imsMap = _.invert(language.imsLocalesMapping);
            var translations, bonusName, bonusTmplName;

            if (!bonus && !bonusTmpl) {
                console.warn('No Bonus And Bonus Template');
            }

            bonusTmpl = bonusTmpl || {};
            bonus = bonus || {};

            translations = bonusTmpl.bonusTranslations;
            bonusName = bonusTmpl.marketingName;
            bonusTmplName = bonusTmpl.name;

            translations && translations.forEach(function(item) {
                const langCode = item.languageCode.toLowerCase();

                if (imsMap[langCode] === lang || langCode === language.getTwoLetterLanguage(lang)) {
                    bonusName = item.marketingName || bonusName;
                    bonusTmplName = item.name || bonusTmplName;
                }
            });

            return bonusName || bonus.marketingName || bonus.templateName || bonusTmplName;
        }
    };
});
